<template>
  <!-- READ ONLY MODE -->
  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div>
      <div class="row justify-content-start">
        <div class="col-auto pl-0 pr-0" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
          <div class="language-name">{{ langOptionobj.languageName }}</div>
          <div class="form-group clearfix" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
            <div>
              <span v-if="question.subType && question.subType.toLowerCase() === 'multi'">
                <input type="checkbox" id="checkbox" disabled />
              </span>
              <span v-else>
                <input type="radio" id="radio" disabled />
              </span>
              <img class="col-lg-2 img-size" :src="option.imageUrl" />
            </div>
          </div>
          <div v-if="question.isDisplayOtherOptionContentField">
            <div class="form-group clearfix">
              <div>
                <span v-if="question.subType && question.subType.toLowerCase() === 'multi'">
                  <input type="checkbox" id="checkbox" disabled />
                </span>
                <span v-else>
                  <input type="radio" id="radio" disabled />
                </span>
                <span class="ml-10" maxlength="10">{{ question.otherOptionContentField }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="p-0 pb-10 clearfix">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>

    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 pl-0 pr-0 mb-25" :class="Math.ceil(loopIndex % 2) == 0 ? 'clearfix' : ''" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
        <h5>
          <span class="mr-5" v-if="loopIndex == 0">Answer choices:</span>
          <span v-if="languagesString && languagesString.length > 0">({{ languagesString }})</span>
          <span v-else-if="loopIndex == 0">({{ langOptionobj.languageName }})</span>
          <span v-else>{{ langOptionobj.languageName }}</span>
        </h5>
        <div class="row form-group clearfix pb-40" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
          <div v-if="option.enabled !== false" class="col-lg-11 p-0">
            <div class="col-md-2 pl-0 pr-20" v-if="option.imageUrl">
              <img class="img_size" :src="option.imageUrl" />
            </div>
            <div class="col-md-2 file_container pl-0">
              <span class="file_container_text">Upload Image</span>
              <input
                type="file"
                class="form-control-file language-img-file"
                :id="'file_upload_' + langOptionobj.languageId + '_' + option.sequence"
                @change="
                  uploadOptionImage($event, loopIndex, optionIndex);
                  return false;
                "
              />
              <a class="color_red cursor_pointer fs-12 mt-10 d-block" v-if="option.imageId" v-on:click="deleteImageQuestionOption(loopIndex, optionIndex)">
                <i class="fa fa-trash fs-18" aria-hidden="true"></i>
              </a>
            </div>
            <div class="col-md-7 text-style">Upload a photo answer choice</div>
          </div>
          <div class="col-lg-1 p-0 score_cls">
            <h5 class="score_text image_score_text">Score</h5>
            <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input image_score_input" v-model.number="option.score">
              <input v-model.number="option.score" oninput="javascript:this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" value="999" type="number" class="integer-plus-minus-input text-left pl-4" />
            </integer-plusminus>
          </div>
        </div>
        <div class="add_another_answer">
          <!-- v-if="addAnotherImgAnswerStatus.includes(langOptionobj.languageId) || langOptionobj.languageName.toLowerCase()=='english' "-->
          <a v-on:click="addAnotherImageAnswer(loopIndex)" class="color_1f95f2">Add another answer</a>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="pt-15 fs-15 mb-20">
        <label class>
          <input type="checkbox" v-model="question.isDisplayOtherOptionContentField" />
          <span class="text-align">Add an "Other" answer option or comment field</span>
        </label>
      </div>
      <template v-if="question.isDisplayOtherOptionContentField">
        <div class="col-md-12" v-if="question.isDisplayOtherOptionContentField">
          <div class="ml-10">
            <b>Label</b>
          </div>
          <div class="ml-10 col-md-4 mb-20 pl-0">
            <b-form-input type="text" class="fs-15 form-control-sm mt-10 field-h40" v-model="question.otherOptionContentField" placeholder="Other" size="sm"></b-form-input>
          </div>
        </div>
        <div v-if="question.isDisplayOtherOptionContentField" class="ml-10 pt-15 fs-15 mb-20">
          <label class="ml-12">
            <input type="checkbox" class v-model="question.isDisplayOtherCommentSelectedField" />
            <span class="text-align">Provide comment field if "Other" is selected</span>
          </label>
        </div>
        <div class="ml-10 col-md-12" v-if="question.isDisplayOtherCommentSelectedField">
          <div>
            <b>If left blank, display this error message:</b>
          </div>
          <div class="col-md-4 pt-5 pb-15 pl-0">
            <b-form-input type="text" class="fs-15 form-control mt-10 field-h40" v-model="question.otherCommentSelectedField" placeholder="Please enter a comment." size="sm"></b-form-input>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import _ from "lodash";
import sampleQuestionObj from "@/components/survey-builder/surveyQuestion.json";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { v4 as uuidv4 } from "uuid";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepImage",
  mixins: [activityStepCustomMessage],
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    IntegerPlusminus,
    quillEditor
  },
  watch: {
    "question.useEnglishImageAnswer": {
      deep: true,
      handler() {
        if (this.activityDetails) {
          this.prepareLanguageString();
          this.prepareLanguageImageOptions();
        }
      }
    },
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  data() {
    return {
      languagesString: null,
      isAddHelpEnabled: false
    };
  },

  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    uploadOptionImage(event, langIndex, optionIndex) {
      const selectedImage = event.target.files[0];
      //
      const languageId = this.question.languageImageOptions[langIndex].languageId;
      const option = this.question.languageImageOptions[langIndex].options[optionIndex];
      const id = "file_upload_" + languageId + "_" + option.sequence;
      const input = window.document.getElementById(id);

      if (selectedImage.size < 10485760) {
        if (input.files[0] && this.validateImage(input.files[0]) == null) {
          this.$toastr.error("Image upload failed. Please try again.");
          event.target.value = null;
          return;
        }
      } else {
        this.$this.$toastr.error("File size exceeds the maximum of 10MB.");
        event.target.value = null;
        return;
      }
      const rand = Math.random()
        .toString(36)
        .substr(2, 10);
      const imageId = option.imageId ? option.imageId : `img_id_${rand}`;
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: input.files[0].name,
          contentType: input.files[0].type,
          sequence: option.sequence,
          imageId: imageId,
          languageId: languageId,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityUploadFact(this.activityDetails.id, file).then(
          response => {
            this.question.languageImageOptions[langIndex].options[optionIndex].imageUrl = response.data.result.imageUrl;
            this.question.languageImageOptions[langIndex].options[optionIndex].imageId = response.data.result.imageId;
            this.question.languageImageOptions[langIndex].options[optionIndex].sequence = response.data.result.sequence;
            this.$toastr.success("Image uploaded successfully");
            window.$("#" + id).val(null);
            this.$forceUpdate();
          },
          error => {
            this.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(this.errorMsg);
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    },
    deleteImageQuestionOption(langIndex, optionIndex) {
      const optionToDelete = this.question.languageImageOptions[langIndex].options[optionIndex];
      optionToDelete.languageId = this.question.languageImageOptions[langIndex].languageId;
      this.$api.deleteActivityOptionFact(this.activityDetails.id, optionToDelete).then(
        () => {
          this.question.languageImageOptions[langIndex].options.splice(optionIndex, 1);
          // updating the sequence number once the option is deleted
          this.question.languageImageOptions[langIndex].options.forEach((option, ind) => {
            option.sequence = ind + 1; //Since it is mutating the original object no need to assing back to the options
          });
          this.$toastr.success("Option deleted successfully");
          window.$('#file_upload[type="file"]').val(null);
          this.toggleAddAnotherImgAnswerLink();
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while deleting the option.";
          this.$toastr.error(this.errorMsg);
        }
      );
    },
    addAnotherImageAnswer(languageIndex) {
      let maxSequence = Number(_.max(_.map(this.question.languageImageOptions[languageIndex].options, "sequence")));

      if (!maxSequence) {
        maxSequence = this.question.languageImageOptions[languageIndex].options.length;
      }

      this.question.languageImageOptions[languageIndex].options.push({
        body: null,
        sequence: maxSequence + 1,
        nextQuestion: null,
        imageUrl: null,
        priority: 0
      });

      this.toggleAddAnotherImgAnswerLink();
      this.$forceUpdate();
      this.init();
    },
    validateImage(image) {
      const isValid = image.name.match(/.(png|jpg|svg)$/i);
      return isValid;
    },
    prepareLanguageString() {
      this.languagesString = null;
      if (this.question.useEnglishImageAnswer) {
        this.languagesString = _.chain(this.activityDetails.language)
          .sortBy("sort_Order")
          .map("name")
          .join(", ")
          .value();
      }
    },
    prepareLanguageImageOptions() {
      const self = this;

      if (self.activityDetails && self.activityDetails.language) {
        /**
         if the user is converting question to image type from other type then we do not have languageImageOptions key
         so lets add it.
         */
        if (!self.question.languageImageOptions && self.question.id) {
          self.question.languageImageOptions = _.cloneDeep(sampleQuestionObj.languageImageOptions);
          self.question.useEnglishImageAnswer = true;
          //Prepare the default english option
          self.prepareEnglishOption();
          self.prepareLanguageString();
        }

        /** The below code is for new question, Update the language id and name to the default(English) languageImageOptions object */
        if (!self.question.id) {
          self.prepareEnglishOption();
        }

        /**Prepare the options for all the languages when the "Use English image answer choices for all languages." checkbox is unchecked */
        if (!self.question.useEnglishImageAnswer) {
          /** If its a new question OR languageImageOptions length is less than the configured languages  */
          if ((!self.question.id || self.question.languageImageOptions.length < self.activityDetails.language.length) && self.question.languageImageOptions.length != self.activityDetails.language.length) {
            const clonedLanguagearray = _.cloneDeep(self.activityDetails.language);
            _.remove(clonedLanguagearray, function(n) {
              //Remove english along with language that are already exists in the question
              return n.name.toLowerCase() == "english" || _.findIndex(self.question.languageImageOptions, ["languageId", n.language_id]) >= 0;
            });
            const otherLanguOptArr = self.preparelanguagesImageoptionsArray(clonedLanguagearray);
            self.question.languageImageOptions = self.question.languageImageOptions.concat(otherLanguOptArr);
          }
        } else {
          //the below code will keep the english object and reove all other from the main question obj
          _.remove(self.question.languageImageOptions, function(n) {
            return n && n.languageName && n.languageName.toLowerCase() !== "english";
          });
        }
        this.toggleAddAnotherImgAnswerLink();
      }
    },
    prepareEnglishOption() {
      const elObj = _.find(this.activityDetails.language, function(o) {
        return o.name.toLowerCase() === "english";
      });
      if (elObj) {
        this.question.languageImageOptions[0].languageId = elObj.language_id;
        this.question.languageImageOptions[0].languageName = elObj.name;
        this.question.languageImageOptions[0].languageCulture = elObj.language_culture;
      }
    },
    toggleUseEnglishImageAnswerCheckbox() {
      this.prepareLanguageString();
      this.prepareLanguageImageOptions();
    },
    preparelanguagesImageoptionsArray(languagesArray) {
      const self = this;
      const langImgOptionsArray = [];

      _.forEach(_.sortBy(languagesArray, "sort_Order"), function(langObj, keyIndex) {
        langImgOptionsArray[keyIndex] = _.cloneDeep(self.question.languageImageOptions[0]);
        langImgOptionsArray[keyIndex].languageId = langObj.language_id;
        langImgOptionsArray[keyIndex].languageName = langObj.name;
        langImgOptionsArray[keyIndex].languageCulture = langObj.language_culture;
        _.forEach(langImgOptionsArray[keyIndex].options, function(op) {
          op.body = null;
          op.formattedBody = null;
          op.nextQuestion = null;
          op.imageUrl = null;
          op.imageId = null;
          op.score = 0;
        });
      });

      return langImgOptionsArray;
    },
    toggleAddAnotherImgAnswerLink() {
      const self = this;

      //check for the other language options length
      const langImgOptClone = _.cloneDeep(self.question.languageImageOptions);

      _.remove(langImgOptClone, function(n) {
        return n && n.languageName && n.languageName.toLowerCase() == "english";
      });
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "" || !question.sequence) {
        errorObj.isValid = false;
        errorObj.msg = "Step content is required.";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      const langImgOptClone = _.cloneDeep(this.question.languageImageOptions);

      //Minimum no. of options should be 2
      const minOptions = _.map(langImgOptClone, function(lo) {
        return lo.options.length;
      });
      const minOptErr = _.some(minOptions, function(v) {
        return v < 2;
      });
      if (minOptErr) {
        errorObj.isValid = false;
        errorObj.msg = "Please upload at least 2 options.";
        return errorObj;
      }
      if (question.isDisplayOtherOptionContentField && (question.otherOptionContentField == null || question.otherOptionContentField.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Label is required.";
        return errorObj;
      }
      if (question.isDisplayOtherOptionContentField && this.question.otherOptionId == null) {
        this.question.otherOptionId = uuidv4();
      }
      if (question.isDisplayOtherCommentSelectedField && (question.otherCommentSelectedField == null || question.otherCommentSelectedField.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Comment is required.";
        return errorObj;
      }
      if (!question.isDisplayOtherOptionContentField) {
        delete this.question.otherOptionId;
        delete this.question.otherOptionContentField;
        delete this.question.otherCommentSelectedField;
        question.isDisplayOtherCommentSelectedField = false;
      }
      if (!question.isDisplayOtherCommentSelectedField) {
        delete this.question.otherCommentSelectedField;
      }

      /**
       CODE TO CHECK THAT USER HAS UPLOADED IMAGES OR NOT
       */
      for (let a = 0; a < langImgOptClone.length; a++) {
        for (let b = 0; b < langImgOptClone[a].options.length; b++) {
          if (!langImgOptClone[a].options[b].imageUrl) {
            a = langImgOptClone.length; //break the loop

            errorObj.isValid = false;
            errorObj.msg = "Please upload image(s)";
            return errorObj;
          }
        }
      }
      // CODE END

      //check if all language has same no. of images options or not
      const hasSameOpt = _.every(minOptions, function(v, i, a) {
        return v === a[0];
      });
      if (!hasSameOpt) {
        this.$toastr.warning("Please upload the same number of images for all languages.");
      }

      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }

      return {
        isValid: true
      };
    },
    init() {
      if (!this.question.id) {
        const questionImage = this.question;
        for (let key = 0; key < questionImage.languageImageOptions.length; key++) {
          for (let j = 0; j < questionImage.languageImageOptions[key].options.length; j++) {
            this.$set(questionImage.languageImageOptions[key].options[j], "score", 0);
          }
        }
      }
    }
  },
  mounted() {
    if (this.mode == "EDIT") {
      this.prepareLanguageString();
      this.prepareLanguageImageOptions();
    }
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    this.init();
  }
};
</script>

<style scoped lang="scss">
.file_container [type="file"] {
  cursor: inherit;
  display: block;
  font-size: 20px;
  filter: alpha(opacity=0);
  width: 80px;
  height: 31px;
  max-height: 50px;
  max-width: 300px;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0px;
  left: 0px;
  z-index: 100;
}
.file_container [type="file"].language-img-file {
  cursor: pointer;
  display: block;
  filter: alpha(opacity=0);
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  height: auto;
  border: 1px solid red;
  font-size: initial;
}
.file_container {
  padding: 0px 10px 0 0;
  color: grey;
}
.file_container [type="file"] {
  cursor: pointer;
}
.file_container_text {
  background-color: #d3dfe4;
  padding: 5px;
  width: 100%;
  display: block;
  border-radius: 4px;
  text-align: center;
  color: #959fa4;
}
.img_size {
  width: 100%;
  height: 100%;
  border: 1px solid #d3dfe4;
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
  text-align: center;
}

.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -38px;

  &.right-position {
    right: 637px;
  }
}
</style>
